module.exports = __webpack_public_path__ + "img/Periscope_app_mock_industrial_monitor 2.00b95b26.png";